// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type SupportAgent20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const SupportAgent20: FC<SupportAgent20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <path d="M9 17v-1.5h6.5V9.938q0-2.292-1.6-3.907-1.6-1.614-3.895-1.614t-3.9 1.614T4.5 9.938v4.729h-1q-.62 0-1.06-.453A1.5 1.5 0 0 1 2 13.125v-1.542q0-.48.27-.854.271-.375.73-.479l.063-1.062a7.4 7.4 0 0 1 .791-2.448 7.1 7.1 0 0 1 1.531-1.97A7 7 0 0 1 7.5 3.47 6.8 6.8 0 0 1 10 3a6.7 6.7 0 0 1 2.496.47 7.05 7.05 0 0 1 3.65 3.26q.604 1.125.791 2.437L17 10.25q.438.105.719.448T18 11.5v1.75q0 .459-.281.802A1.3 1.3 0 0 1 17 14.5v1q0 .619-.44 1.06-.44.44-1.06.44zm-1.246-5.5a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535A.71.71 0 0 1 7.746 10q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m4.5 0a.74.74 0 0 1-.535-.214.71.71 0 0 1-.219-.532q0-.316.214-.535a.71.71 0 0 1 .532-.219q.316 0 .535.214t.219.532-.214.535a.71.71 0 0 1-.532.219m-6.733-1.042q-.187-2.02 1.16-3.49Q8.03 5.502 10.041 5.5a4.27 4.27 0 0 1 2.97 1.146q1.26 1.146 1.447 2.854a5.66 5.66 0 0 1-3.218-.969A6.57 6.57 0 0 1 9 6a6.3 6.3 0 0 1-1.198 2.656 5.9 5.9 0 0 1-2.281 1.802" />
        </svg>
    );
};

export default SupportAgent20;
